'use strict';


var identifiers = require('./modules/identifiers'),
    gettextWrapper = require('mag-gettext'),
    stbDisplayManager = top.stbDisplayManager,
    gettext;


function generateOptions ( config ) {
    var options = [
            {
                id: identifiers.deviceInfo,
                icon: 'theme-icon-rc-info',
                name: gettext('Device info'),
                description: require('./modules/data/device.info'),
                render: config.api.renders.listItem,
                saveImmediate: true,
                parent: identifiers.system
            },
            {
                id: identifiers.interfaceLanguage,
                name: gettext('Language'),
                description: gettext('Change interface language'),
                icon: 'theme-icon-languages',
                environment: {
                    language: 'en'
                },
                requirePortalReboot: true,
                prepareForRender: function ( environment, callback ) {
                    callback(require('./data/languages').map(function ( language ) {
                        language.selected = environment.language === language.value;

                        return language;
                    }));
                },
                prepareForSave: function ( value, callback ) {
                    this.environment.language = value;

                    callback();
                },
                render: config.api.renders.popupSelect,
                getter: config.api.getters.environment,
                saver: config.api.savers.environment,
                parent: identifiers.system
            }
        ],
        timeZoneEnvironment = {},
        timeZoneEnvironmentName = 'timezone_conf';


    if ( core.device.model !== 'emulator' && core.device.model !== 'AndroidAPP' ) {
        timeZoneEnvironment[timeZoneEnvironmentName] = 'Europe/Kiev';
        options.push({
            id: identifiers.deviceTimezone,
            name: gettext('Timezone'),
            description: gettext('Select your time zone'),
            icon: 'theme-icon-timezone',
            environment: timeZoneEnvironment,
            prepareForRender: function ( data, callback ) {
                callback(require('./modules/data/timezones').map(function ( timezone ) {
                    timezone.selected = timezone.value === data[timeZoneEnvironmentName];

                    return timezone;
                }));
            },
            prepareForSave: function ( value, callback ) {
                this.environment[timeZoneEnvironmentName] = value;
                /* eslint-disable-next-line new-cap */
                top.gSTB.ExecAction('timezone ' + value);

                callback();
            },
            render: config.api.renders.popupSelect,
            getter: config.api.getters.environment,
            saver: config.api.savers.environment,
            parent: identifiers.system
        });
    }

    if (
        MODE !== 'PORTAL'
        && core.device.model !== 'emulator'
        && core.device.model !== 'emulator_stb'
    ) {
        options.unshift({
            id: identifiers.loadEmbeddedPortal,
            name: gettext('Load embedded portal'),
            description: gettext('Load embedded portal'),
            icon: 'theme-icon-home',
            confirmation: {
                title: gettext('Load embedded portal?'),
                callback: function ( result ) {
                    if ( result ) {
                        config.api.actions.loadEmbedPortal();
                    }
                }
            },
            render: config.api.renders.confirm,
            parent: identifiers.root
        });
    }

    return options;
}

function generateHdmiCecOption ( config ) {
    return {
        id: 'hdmiCec',
        advanced: true,
        name: gettext('HDMI-CEC'),
        title: gettext('HDMI-CEC'),
        description: [
            {
                label: gettext('HDMI-CEC'),
                value: core.environment.cec
            }
        ],
        icon: 'theme-icon-display',
        environment: {
            cec: 'false'
        },
        prepareForRender: function ( environment, callback ) {
            var graphicResolutions = [
                {value: 'false', name: gettext('Disabled'), selected: environment.cec === 'false'},
                {value: 'true', name: gettext('Enabled'), selected: environment.cec === 'true'},
                {value: 'once', name: gettext('Enable once'), selected: environment.cec === 'once'}
            ];

            top.console.log(environment.cec);

            callback(graphicResolutions);
        },
        prepareForSave: function ( value, callback) {
            var displayIndex = 0,
                cecState = value;


            switch ( value ) {
                case 'once':
                    value = 'false';

                /* eslint-disable-next-line no-fallthrough */
                case 'true':
                    cecState = true;
                    break;

                default:
                    cecState = false;
                    value = 'false';
                    break;
            }

            while ( displayIndex < stbDisplayManager.list.length ) {
                stbDisplayManager.list[displayIndex].cec = cecState;
                displayIndex++;
            }

            this.environment.cec = value;

            callback();
        },
        saveImmediate: true,
        render: config.api.renders.popupSelect,
        getter: config.api.getters.environment,
        saver: config.api.savers.environment,
        parent: 'userInterface'
    };
}


function generateAccessControlSettings ( content, config ) {
    content.push({
        id: identifiers.parentControlStatus,
        type: 'option',
        name: gettext('Status'),
        description: gettext('Enable / Disable parental control'),
        icon: 'theme-icon-avatar',
        render: config.api.renders.toggle,
        parent: identifiers.parentControl,
        value: core.accessControl.settings.active,
        getter: function ( done ) {
            setTimeout(function () {
                done(false, core.accessControl.settings.active);
            }, 0);
        },
        saveImmediate: true,
        saver: function ( done ) {
            core.accessControl.settings.update({
                active: this.value
            }, function ( error ) {
                done(error);
            });
        },
        prepareForRender: function ( currentValue, done ) {
            done(currentValue);
        },
        prepareForSave: function ( value, done ) {
            this.value = value;

            done();
        }
    });

    content.push({
        id: identifiers.parentControlPassword,
        type: 'option',
        name: gettext('Password'),
        description: gettext('Setting the parental control password. The default password is 0000.'),
        icon: 'theme-icon-lock',
        parent: identifiers.parentControl,
        events: {
            click: function () {
                core.accessControl.settings.updatePassword();
            }
        },
        saver: function ( done ) {
            done();
        }
    });

    content.push({
        id: identifiers.parentControlSessionTime,
        type: 'option',
        name: gettext('Timer'),
        description: gettext('Setting Parental Control query interval. After this time period has elapsed, you will need to re-enter the password.'),
        icon: 'theme-icon-clock',
        render: config.api.renders.popupSelect,
        parent: identifiers.parentControl,
        value: core.accessControl.settings.sessionTime,
        getter: function ( callback ) {
            setTimeout(function () {
                callback(false, core.accessControl.settings.sessionTime);
            }, 0);
        },
        saveImmediate: true,
        saver: function ( callback ) {
            core.accessControl.settings.update({
                sessionTime: this.value
            }, callback);
        },
        prepareForRender: function ( value, callback ) {
            callback(require('./data/parent.control.session.timers').map(function ( item ) {
                item.selected = item.value === value;

                return item;
            }));
        },
        prepareForSave: function ( value, callback ) {
            this.value = value;

            callback();
        }
    });
}


// public interface
module.exports = {
    onSettingsInit: function ( config, callback ) {
        gettextWrapper.load({
            name: core.environment.language,
            path: config.path + 'lang'
        }, function () {
            var data;

            gettext = require('mag-gettext').gettext;
            data = {
                id: identifiers.root,
                name: gettext('root section'),
                description: gettext('root section general description'),
                sections: require('./modules/sections'),
                options: generateOptions(config),
                content: []
            };

            if ( stbDisplayManager && stbDisplayManager.list.length && 'cec' in stbDisplayManager.list[0] ) {
                data.options.push(generateHdmiCecOption(config));
            }

            if ( core.accessControl ) {
                generateAccessControlSettings(data.content, config);
            }

            callback(null, data);
        });
    }
};
